export const VESSELS_TYPE = {
  EXCISE: "EXCISE",
  CARGO: "CARGO",
  OTHER: "OTHER",
  TANKER: "TANKER",
  PASSENGER: "PASSENGER",
};

export const TANKER_NAME = {
  D_STAR: "DSTAR",
  VENUS20: "VENUS20",
  TONGWATTANA: "TONGWATTANA",
  TARA: "TARA",
  PASSAWE2: "PASSAWE2",
  P_SIMILUN: "P.SIMILUN",
  IRPC: "IRPC",
  SPRC: "SPRC",
  TOP: "TOP",
  PTTGC: "PTTGC",
  ESSO: "ESSO",
  BCP: "BCP",
};

export const REFINERY_NAME = {
  IRPC: "IRPC",
  SPRC: "SPRC",
  TOP: "TOP",
  PTTGC: "PTTGC",
  ESSO: "ESSO",
  BCP: "BCP",
  ALL: "ALL",
};
export const REFINERY_ID = {
  IRPC: "HQ0000000002",
  SPRC: "HQ0000000005",
  TOP: "HQ0000000001",
  PTTGC: "HQ0000000006",
  ESSO: "HQ0000000004",
  BCP: "HQ0000000007",
};

export const DIRECT_TREE_TYPE = {
  REFINERY: "Refinery",
  OIL: "oil",
  TANKER: "Tanker",
  VESSEL: "vessel",
  TRANSFER: "transfer",
};

export const TANKER_TYPE = {
  TRANSFER: "transfer",
  TANKER: "tanker",
  VESSEL: "vessel",
  OIL: "oil",
  LINE: "line",
};

export const OIL_TYPE = {
  GREEN_DIESEL: "greenDiesel",
  DOMESTIC_OIL: "domesticOil",
  EXPORT_OIL: "exportOil",
  ALL: "all"
};

export const OIL_PRICE = {
  HQ0000000001: 13.0108,//เบนซิล
  HQ0000000002: 13.6816,//diesel
  HQ0000000003: 9.5317,//น้ำมันเตา
  HQ0000000004: 1,//อื่นๆ
  HQ0000000005: 1,//น้ำมันหล่อลื่นและน้ำมันที่คล้ายกัน
  HQ0000000006: 1,//น้ำมันก๊าด
  HQ0000000007: 1,//JET
  HQ0000000008: 15.7080,//LPG (ก๊าซปิโตรเลียมเหลว)
  HQ0000000009: 1,//TOPSol BF
  SCS_BK0000000001: 1,//ไฮโดรคาร์บอนโซเว้นท์
};

export const STATIONS = {
  1: "ไทยออยล์",
  2:"ไออาร์พีซี",
  4: "สตาร์ปิโตรเลียมรีไฟน์นิ่ง",
  5: "พีทีที โกลบอล เคมิคอล"
};

